import * as React from 'react'
import { Fragment, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import Loader from '../Loader/Loader';
import { useHookStore } from '../../hook-store/store';
import { ollamaMcpTranslate } from '../../utils/ollama/ollama-util';

import {
  loginPageLink,
  signupPageLink,
 } from '../../lib/api';

import { marks } from '../../utils/marks';
// import { marks } from '~utils/marks'
import classes from './LoginButtons.module.css';



const LoginButtons = (props) => {
  const {
    hideSignup,
  } = props;

  const [t] = useTranslation('translation')

  const [store, dispatch] = useHookStore();
  const { isAuth } = store.uiStore;


  let loginButtonsBody;

  loginButtonsBody = (
    <div>
      <div className={classes.loginButtonsRow}>
        <a href={loginPageLink}>
          <button className="btnBase">
            {marks.signInMrak} {t('nptPageFound.06', 'Login')}
          </button>
        </a>
        {!hideSignup && (
          <span>
            <span> {t('nptPageFound.07', 'or')} </span>
            <a href={signupPageLink}>
              <button className="btnBase">
                {marks.userPlusMrak} {t('nptPageFound.08', 'Signup')}
              </button>
            </a>
          </span>
        )}
      </div>
    </div>
  );

  return (
    <Fragment>
      {loginButtonsBody}
    </Fragment>
  );
}

export default LoginButtons;
